import React, { useState, useEffect, useRef } from "react";
import { Stack, PrimaryButton, TextField, Dropdown } from "@fluentui/react";
// Added by Gauri to fix dropdown position issue on 20 Nov 2025
import { DirectionalHint } from "@fluentui/react";
import { Table, Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import { Tooltip } from "@mui/material";
import { Dialog, DialogFooter, DialogType } from "@fluentui/react";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1";

// Added by Gauri for Role Access on 06 May 2025
const EarlyWarnings = ({
  riskID,
  item,
  initiativesID,
  statuses,
  selectedKey,
  acc,
  getViewOptions,
}) => {
  const [showForm, setShowForm] = useState(false); // State to toggle between form and table
  const [refetch, setRefetch] = useState(false);
  const [newWarning, setNewWarning] = useState({
    warningStatus: "",
    warning: "",
    warningID: "",
  });
  const [earlyWarningData, setEarlyWarningData] = useState([]);
  const [editIndex, setEditIndex] = useState(null); // State to track which warning is being edited
  console.log(riskID, "riskkk");
  // State for the delete modal
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [warningToDelete, setWarningToDelete] = useState(null);
  const [id, setId] = useState(null);
  // Refs for mandatory fields
  const warningStatusRef = useRef(null);
  const warningRef = useRef(null);

  const [editMode, setEditMode] = useState(false);
  const earlyWarningPermission = getViewOptions?.[3] || {};
  console.log("earlyWarningPermission", earlyWarningPermission);
  const {
    a: canAdd,
    e: canEdit,
    d: canDelete,
    v: canView,
  } = earlyWarningPermission;
  const hasAnyPermission = canAdd || canEdit || canDelete || canView;

  useEffect(() => {
    const fetchEarlyWarningData = async () => {
      try {
        const token = sessionStorage.getItem("access_token");
        const response = await AxiosInstance1.get(
          `/api/InitiativeRisk/GetRiskEarlyWarningList?RiskID=${riskID}`
          // {
          //   headers: {
          //     Authorization: `Bearer ${token}`
          //   }
          // }
        );
        console.log("Early Warning Data:", response.data);
        setEarlyWarningData(response?.data?.data?.listRiskEarlyWarning);
      } catch (error) {
        console.error("Error fetching early warning data:", error);
        toast.error("Failed to fetch early warning data.");
      }
    };

    fetchEarlyWarningData();
  }, [refetch, selectedKey]);

  const saveNewWarning = async () => {
    const { warningStatus, warning, warningID } = newWarning;

    // Check if mandatory fields are filled
    if (!warningStatus) {
      toast.error("Warning Status should not be left blank");
      warningStatusRef.current.focus(); // Focus the Warning Status field
      return;
    }
    if (!warning) {
      toast.error("Warning should not be left blank");
      warningRef.current.focus(); // Focus the Warning field
      return;
    }

    const userdata = JSON.parse(sessionStorage.getItem("user"));
    const userID = userdata?.employeeId;

    try {
      const token = sessionStorage.getItem("authToken");

      let url; // Declare the url with 'let' since it will change based on the condition
      let method; // Define the method based on editing or adding
      let params = {
        riskID,
        warningID: id, // Ensure the ID is passed in case of edit
        IdeaID: initiativesID,
        WarningStatus: warningStatus,
        strWarning: warning,
        userID,
      };
      console.log("warningStatus", params);
      if (editIndex !== null) {
        // For editing an existing warning (PUT request)
        url = `/api/InitiativeRisk/UpdateEarlyWarning`;
        method = "put"; // Set method to PUT for editing
      } else {
        // For adding a new warning (POST request)
        url = `/api/InitiativeRisk/PostEarlyWarning`;
        method = "post"; // Set method to POST for adding new warning
      }

      // Send the appropriate request based on the method
      const response = await AxiosInstance1.request({
        method,
        url,
        params,
        // headers: {
        //   Authorization: `Bearer ${sessionStorage.getItem("access_token")}`
        // }
      });

      // Handle success response
      if (response.status === 200) {
        if (editIndex !== null)
          toast.success("Early warning updated successfully!");
        else toast.success("Early warning saved successfully!");
        // Reset the form and UI state
        setNewWarning({ warningStatus: "", warning: "", warningID: "" });
        setShowForm(false);
        setId(null);
        setEditIndex(null); // Reset edit index
        setRefetch(!refetch);
      }
    } catch (error) {
      console.error("Error saving warning:", error);
      toast.error("Failed to add or update early warning. Please try again.");
    }
  };

  const deleteWarning = (warning) => {
    console.log("warning", warning);
    const accessToken = sessionStorage.getItem("access_token");
    const userdata = JSON.parse(sessionStorage.getItem("user"));
    const employeeId = userdata?.employeeId;
    AxiosInstance1.delete(
      `/api/InitiativeRisk/DeleteRiskEarlyWarnings?EarlyWarningID=${warning.warningID}&UserID=${employeeId}`
      // { headers: { Authorization: `Bearer ${accessToken}` } }
    )
      .then(() => {
        // Close the modal and delete the warning
        setShowDeleteModal(false);
        setRefetch(!refetch);
        setEarlyWarningData(
          earlyWarningData.filter(
            (item) => item.warningID !== warning.warningID
          )
        );
        toast.success("Early Warnings deleted successfully!");
      })
      .catch((error) => {
        console.error("Error deleting warning:", error);
        toast.error("Failed to delete early warning.");
      });
  };

  const handleEdit = (index) => {
    const warningToEdit = earlyWarningData[index];
    console.log("warningID", warningToEdit);
    setId(warningToEdit.warningID);
    setNewWarning({
      warningStatus: warningToEdit.warningStatus,
      warning: warningToEdit.warning,
      warningID: warningToEdit.warningID,
    });
    setEditIndex(index); // Set the index of the warning being edited
    setShowForm(true); // Show the form to edit
  };

  const handleDeleteClick = (warning) => {
    setWarningToDelete(warning); // Set the warning to delete
    setShowDeleteModal(true); // Show the delete modal
  };

  // Added by Gauri on 20 Nov 2025 - Common calloutProps for all dropdowns
  const commonCalloutProps = {
    // Use bottomAutoEdge which tries to open downward first, then automatically adjusts upward if needed
    directionalHint: DirectionalHint.bottomAutoEdge,
    // Set max height to prevent dropdown from being too large
    calloutMaxHeight: 250,
    // Ensure dropdown stays within viewport bounds
    bounds: typeof window !== 'undefined' ? {
      top: 0,
      left: 0,
      bottom: window.innerHeight,
      right: window.innerWidth
    } : undefined
  };

  console.log("statuses", statuses);
  return (
    <div>
      <Stack horizontal horizontalAlign="end" className="">
        {acc[0]?.access !== 0 && (
          <>
            {/* Added by Gauri for Role Access on 06 May 2025 */}
            {!showForm && canAdd && (
              <PrimaryButton
                text="Add"
                onClick={() => {
                  if (showForm) {
                    setShowForm(false);
                    setNewWarning({
                      warningStatus: "",
                      warning: "",
                      warningToEdit: "",
                    });
                    setEditIndex(null); // Reset edit index
                    setEditMode(false); // Added by Gauri for Role Access on 06 May 2025
                  } else {
                    setNewWarning({
                      warningStatus: "",
                      warning: "",
                      warningToEdit: "",
                    });
                    setShowForm(true);
                  }
                }}
              />
            )}
          </>
        )}
      </Stack>

      {showForm && (
        <div className="mt-4">
          {/* <h3 className="mt-4">{editIndex !== null ? "Early Warning" : "Early Warning"}</h3> */}
          <Stack
            horizontal
            horizontalAlign="end"
            tokens={{ childrenGap: 8 }}
            className="mt-2"
          >
            {/* Added by Gauri for Role Access on 06 May 2025 */}
            {((!editMode && canAdd) || (editMode && canEdit)) &&
              acc[2]?.access !== 0 && (
                <PrimaryButton onClick={saveNewWarning} text="Save" />
              )}
            <PrimaryButton
              onClick={() => setShowForm(false)}
              text="Cancel"
              className="ms-2"
            />
          </Stack>
          <div className="col-sm-12 text-end form-group">
            <label className="form-label IM_label">
              (<span style={{ color: "red" }}>*</span> Mandatory)
            </label>
          </div>

          <Stack horizontal tokens={{ childrenGap: 16 }} verticalAlign="start">
            {/* Modified by Gauri to fix dropdown position issue on 20 Nov 2025 */}
            <Dropdown
              label={
                <span>
                  Warning Status <span style={{ color: "red" }}>*</span>
                </span>
              }
              placeholder="Select Warning Status"
              selectedKey={statuses?.find((item) => item.name === newWarning.warningStatus)?.id.toString()}
              // defaultSelectedKey={newWarning.warningStatus?.toString()}
              options={[
                { key: "", text: "Select Warning Status" },
                ...(statuses?.map((item) => ({
                  key: item.id,
                  text: item.name,
                })) || [])
              ]}
              onChange={(e, option) =>
                setNewWarning({ ...newWarning, warningStatus: option?.text })
              }
              styles={{
                root: { minWidth: 200 },
                label: { fontSize: 14 }, // Label style for consistency
              }}
              calloutProps={commonCalloutProps}
            />
            <TextField
              label={
                <span>
                  Warning <span style={{ color: "red" }}>*</span>
                </span>
              }
              value={newWarning.warning}
              multiline
              onChange={(e, newValue) =>
                setNewWarning({ ...newWarning, warning: newValue })
              }
              rows={4} // Adjust to control the number of visible lines
            />
          </Stack>
        </div>
      )}
      <div className="mt-2">
        <strong>Total Records: {earlyWarningData?.length}</strong>
      </div>
      <Table striped bordered hover className="mt-4">
        <thead>
          <tr>
            <th>Warning</th>
            <th>Warning Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {earlyWarningData && earlyWarningData?.length > 0 ? (
            earlyWarningData.map((warning, index) => (
              <tr key={index}>
                <td>{warning.warning}</td>
                <td>{warning.warningStatus}</td>
                <td>
                  <IconButton
                    onClick={() => {
                      handleEdit(index);
                      setEditMode(true); // Added by Gauri for Role Access on 06 May 2025
                    }}
                  >
                    <Tooltip title="Edit">
                      <EditIcon style={{ fontSize: "1rem" }} />
                    </Tooltip>
                  </IconButton>
                  {/* Added by Gauri for Role Access on 06 May 2025 */}
                  {canDelete && (
                    <IconButton onClick={() => handleDeleteClick(warning)}>
                      <Tooltip title="Delete">
                        <DeleteIcon style={{ fontSize: "1rem" }} />
                      </Tooltip>
                    </IconButton>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-center">
                There are no items to show in this view
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <Dialog
        hidden={!showDeleteModal}
        onDismiss={() => setShowDeleteModal(false)}
        dialogContentProps={{
          type: DialogType.normal,
          title: "Confirm Delete",
          subText: "Are you sure, you want to delete this record?",
        }}
      >
        <DialogFooter>
          <PrimaryButton
            onClick={() => warningToDelete && deleteWarning(warningToDelete)}
            text="Yes"
          />
          <PrimaryButton onClick={() => setShowDeleteModal(false)} text="No" />
        </DialogFooter>
      </Dialog>
    </div>
  );
};

export default EarlyWarnings;
